import React from "react";
import AccountDetailsDrawer from "../../component/wallet/AccountDetailsDrawer";
import FundWalletModal from "../../component/wallet/FundWalletModal";
import SelectFundingMethodModal from "../../component/wallet/SelectFundingMethodModal";
import ReceiveViaWalletModal from "../../component/wallet/ReceiveViaWalletModal";
import FundViaConversionModal from "../../component/wallet/FundViaConversionModal";
import GenerateStatementModal from "../../component/wallet/GenerateStatementModal";
import SuccessModal from "../../component/SuccessModal";
import PinModal from "../../component/pay/PinModal";

export default function DashboardModals(props) {
    const {
        // toggles
        showDrawer,
        setShowDrawer,
        showFundModal,
        setShowFundModal,
        showFundingMethodModal,
        setShowFundingMethodModal,
        showReceiveWalletModal,
        setShowReceiveWalletModal,
        showFundViaConversionModal,
        setShowFundViaConversionModal,
        showGenerateModal,
        setShowGenerateModal,
        showSuccessModal,
        setShowSuccessModal,
        showPinModal,
        setShowPinModal,
        // data
        accountNumber,
        accountName,
        bankName,
        account,
        defaults,
        branchName,
        userEmail,
        isDownloading,
        onPinSuccess,
        setOnPinSuccess,
        pinError,
        setPinError,
        bankAddress,
        bankCode,
        routingNumber,
        paymentRails,
    } = props;

    return (
        <>
            <AccountDetailsDrawer
                isOpen={showDrawer}
                onClose={() => setShowDrawer(false)}
                onAddNew={() => {}}
                account={{ currency: defaults, accountNumber, bankName, accountName }}
            />

            <FundWalletModal
                isOpen={showFundModal}
                onClose={() => setShowFundModal(false)}
                walletData={{
                    currency: defaults,
                    accountName,
                    bankName,
                    accountNumber,
                    branchName,
                    bankAddress,
                    bankCode,
                    routingNumber,
                    paymentRails,
                    iban: account?.iban || "",
                    swift: account?.swift || "",
                }}
                providers={account?._raw?.wallet?.providers}
            />

            <SelectFundingMethodModal
                isOpen={showFundingMethodModal}
                onClose={() => setShowFundingMethodModal(false)}
                onWalletOptionSelect={() => {
                    setShowFundingMethodModal(false);
                    setShowReceiveWalletModal(true);
                }}
                onConversionOptionSelect={() => {
                    setShowFundingMethodModal(false);
                    setShowFundViaConversionModal(true);
                }}
            />

            <ReceiveViaWalletModal
                isOpen={showReceiveWalletModal}
                onClose={() => setShowReceiveWalletModal(false)}
                walletAddress={accountNumber}
            />

            <FundViaConversionModal
                isOpen={showFundViaConversionModal}
                onClose={() => setShowFundViaConversionModal(false)}
            />

            <GenerateStatementModal
                show={showGenerateModal}
                onClose={() => setShowGenerateModal(false)}
                wallet={accountNumber}
                email={userEmail}
                setShowSuccessModal={setShowSuccessModal}
                setGeneratedData={() => {}}
                setShowPinModal={setShowPinModal}
                setOnPinSuccess={setOnPinSuccess}
            />

            {showSuccessModal && (
                <SuccessModal
                    show
                    onClose={() => setShowSuccessModal(false)}
                    icon={
                        <div className="p-1 rounded-full">
                            <img
                                src={"asset/icons/SuccessCurrencyConversion.svg"}
                                alt="success"
                                className="w-24 h-24"
                            />
                        </div>
                    }
                    title="Your statement is ready!"
                    message="We’ve sent a copy to your email."
                    buttonText="Done"
                    loading={isDownloading}
                    onButtonClick={() => setShowSuccessModal(false)}
                />
            )}

            <PinModal
                isOpen={showPinModal}
                onClose={() => {
                    setShowPinModal(false);
                    setPinError("");
                }}
                onConfirm={async (enteredPin) => {
                    setPinError("");
                    if (onPinSuccess) {
                        try {
                            await onPinSuccess(enteredPin);
                        } catch (err) {
                            setPinError(
                                err?.response?.data?.message || "Incorrect PIN. Please try again."
                            );
                            throw err;
                        }
                    }
                }}
                header="Enter your PIN to view statement"
                pinErrorMessage={pinError}
            />
        </>
    );
}
